// Mock data for L2 Aetheris - Lineage 2 Private Server

export const SERVER_INFO = {
  name: 'L2 Aetheris',
  tagline: 'Interlude x10 — SubAcu Base +5',
  subtitle: 'La nueva era del Lineage 2 ha comenzado',
  chronicle: 'Interlude',
  status: 'online',
  openingDate: '2025-08-15T21:00:00Z',
  discordUrl: 'https://discord.gg/aetheris',
  facebookUrl: 'https://facebook.com/l2aetheris',
  youtubeUrl: 'https://youtube.com/@l2aetheris',
};

export const LIVE_STATS = {
  online: 2847,
  peak: 4128,
  uptime: '99.98%',
  servers: 2,
  registered: 38420,
  clans: 612,
  alliances: 84,
};

export const FEATURES = [
  {
    id: 1,
    icon: 'Layers',
    title: 'SubAcu Base +5',
    description: 'Sistema de subclase acumulativa avanzada. Mezcla habilidades de hasta 5 subclases con tu main para crear builds únicos.',
    image: 'https://images.unsplash.com/photo-1667601998053-cd19b2ceb5a5',
  },
  {
    id: 2,
    icon: 'Sparkles',
    title: 'Custom Interface',
    description: 'Interface modernizada con autoplay inteligente, auto-buff, party finder y dashboard de progreso integrado.',
    image: 'https://images.unsplash.com/photo-1634409884980-a30da0b2b010',
  },
  {
    id: 3,
    icon: 'Gift',
    title: 'Daily Rewards',
    description: 'Recompensas diarias progresivas protegidas por HWID. Streak bonuses y eventos semanales exclusivos.',
    image: 'https://images.unsplash.com/photo-1773216344148-45afea590cf6',
  },
  {
    id: 4,
    icon: 'Swords',
    title: 'Eventos Automáticos',
    description: 'TvT, CtF, Deathmatch, Fortress Wars y bossfights cada hora con rewards escalables y leaderboards en vivo.',
    image: 'https://images.pexels.com/photos/10068853/pexels-photo-10068853.jpeg',
  },
  {
    id: 5,
    icon: 'ShieldCheck',
    title: 'Anti-Bot & Anti-Cheat',
    description: 'Protección de última generación con detección heurística, captcha aleatorio y protección HWID.',
    image: 'https://images.unsplash.com/photo-1600081728723-c8aa2ee3236a',
  },
  {
    id: 6,
    icon: 'Crown',
    title: 'Olympiad & Sieges',
    description: 'Olympiad semanal con premios reales. Castle sieges balanceados con sistema anti-zerg y broadcasting en vivo.',
    image: 'https://images.pexels.com/photos/19249701/pexels-photo-19249701.jpeg',
  },
];

export const RATES = {
  experience: { value: 'x10', label: 'EXP' },
  skillPoints: { value: 'x10', label: 'SP' },
  adena: { value: 'x8', label: 'Adena' },
  drop: { value: 'x6', label: 'Drop' },
  spoil: { value: 'x6', label: 'Spoil' },
  questExp: { value: 'x4', label: 'Quest EXP' },
  questAdena: { value: 'x4', label: 'Quest Adena' },
  raidBoss: { value: 'x3', label: 'Raid Boss' },
  manorRate: { value: 'x5', label: 'Manor' },
};

export const ENCHANT_RATES = [
  { type: 'Normal Scroll', safe: '+3', max: '+16', rate: '66%' },
  { type: 'Blessed Scroll', safe: '+4', max: '+16', rate: '60%' },
  { type: 'Crystal Scroll', safe: '+4', max: '+20', rate: '70%' },
  { type: 'Ancient Scroll', safe: '+5', max: '+25', rate: '75%' },
  { type: 'Attribute Stone', safe: 'N/A', max: '+150', rate: '50%' },
];

export const NEWS = [
  {
    id: 1,
    date: '2025-07-28',
    category: 'EVENTO',
    title: 'Torneo PvP 1v1 — Premio: 500 USD',
    excerpt: 'El primer torneo oficial de Aetheris está aquí. Inscripciones abiertas hasta el 15 de agosto.',
    image: 'https://images.unsplash.com/photo-1773216344148-45afea590cf6',
    pinned: true,
  },
  {
    id: 2,
    date: '2025-07-25',
    category: 'UPDATE',
    title: 'Patch 1.2 — Balance de Clases & Nuevos Bosses',
    excerpt: 'Re-balance completo de healers, nuevo Epic Boss "Valdrak el Eterno" y mejoras en el sistema de craft.',
    image: 'https://images.pexels.com/photos/19249701/pexels-photo-19249701.jpeg',
    pinned: false,
  },
  {
    id: 3,
    date: '2025-07-20',
    category: 'OPEN BETA',
    title: 'Open Beta Test — Únete antes del lanzamiento',
    excerpt: 'Beta abierta hasta el 10 de agosto. Reportes de bugs serán recompensados con items en el live server.',
    image: 'https://images.unsplash.com/photo-1585588985526-9459c1bb9e9e',
    pinned: false,
  },
  {
    id: 4,
    date: '2025-07-15',
    category: 'GRAND OPENING',
    title: 'Grand Opening — 15 de Agosto a las 21:00 GMT',
    excerpt: 'Marca tu calendario. Servidor live con eventos especiales, doble drop la primera semana y rewards de fundador.',
    image: 'https://images.unsplash.com/photo-1514539079130-25950c84af65',
    pinned: true,
  },
  {
    id: 5,
    date: '2025-07-10',
    category: 'COMUNIDAD',
    title: 'Programa de Streamers — Aplicaciones abiertas',
    excerpt: 'Streamers seleccionados reciben items exclusivos, custom titles y revenue share del donate.',
    image: 'https://images.pexels.com/photos/10068853/pexels-photo-10068853.jpeg',
    pinned: false,
  },
];

export const TOP_PLAYERS = [
  { rank: 1, name: 'Valdric', class: 'Duelist', clan: 'Eternal', level: 85, pvp: 4821, pk: 23, online: true },
  { rank: 2, name: 'Nyxara', class: 'Cardinal', clan: 'Eternal', level: 85, pvp: 3950, pk: 12, online: true },
  { rank: 3, name: 'Drakon', class: 'Soultaker', clan: 'Phoenix', level: 85, pvp: 3702, pk: 89, online: false },
  { rank: 4, name: 'Selene', class: 'Hierophant', clan: 'Phoenix', level: 85, pvp: 3501, pk: 8, online: true },
  { rank: 5, name: 'Korvath', class: 'Titan', clan: 'Ravens', clanRole: 'Leader', level: 85, pvp: 3320, pk: 145, online: true },
  { rank: 6, name: 'Lyriel', class: 'Sword Muse', clan: 'Eternal', level: 85, pvp: 3105, pk: 4, online: false },
  { rank: 7, name: 'Mortis', class: 'Dominator', clan: 'Ravens', level: 85, pvp: 2980, pk: 67, online: true },
  { rank: 8, name: 'Aurelia', class: 'Eva\'s Saint', clan: 'Phoenix', level: 84, pvp: 2842, pk: 2, online: true },
  { rank: 9, name: 'Thorgar', class: 'Fortune Seeker', clan: 'Vanguard', level: 84, pvp: 2710, pk: 31, online: false },
  { rank: 10, name: 'Vespera', class: 'Spectral Dancer', clan: 'Vanguard', level: 84, pvp: 2604, pk: 19, online: true },
];

export const TOP_CLANS = [
  { rank: 1, name: 'Eternal', leader: 'Valdric', members: 87, level: 11, reputation: 482100, castle: 'Aden' },
  { rank: 2, name: 'Phoenix', leader: 'Drakon', members: 76, level: 11, reputation: 421800, castle: 'Giran' },
  { rank: 3, name: 'Ravens', leader: 'Korvath', members: 64, level: 10, reputation: 312500, castle: 'Goddard' },
  { rank: 4, name: 'Vanguard', leader: 'Thorgar', members: 58, level: 10, reputation: 287400, castle: '—' },
  { rank: 5, name: 'Tempest', leader: 'Ezra', members: 52, level: 9, reputation: 234100, castle: '—' },
];

export const VOTE_SITES = [
  { id: 1, name: 'Hopzone', url: 'https://l2.hopzone.net', reward: '50 Vote Coins', cooldown: '12h', logo: 'H' },
  { id: 2, name: 'L2Network', url: 'https://l2network.eu', reward: '50 Vote Coins', cooldown: '12h', logo: 'N' },
  { id: 3, name: 'L2JBrasil', url: 'https://top.l2jbrasil.com', reward: '50 Vote Coins', cooldown: '12h', logo: 'B' },
  { id: 4, name: 'L2TopServers', url: 'https://l2topservers.com', reward: '30 Vote Coins', cooldown: '24h', logo: 'T' },
];

export const CLASSES = [
  {
    name: 'Warrior',
    role: 'Tank / DPS',
    description: 'Especialistas en combate cuerpo a cuerpo. Alta defensa y daño físico devastador.',
    image: 'https://images.pexels.com/photos/10068853/pexels-photo-10068853.jpeg',
    subclasses: ['Duelist', 'Titan', 'Grand Khavatari', 'Maestro', 'Doombringer'],
    color: '#a02020',
  },
  {
    name: 'Mystic',
    role: 'DPS / Support',
    description: 'Maestros de la magia arcana. Capaces de devastar campos enteros con hechizos masivos.',
    image: 'https://images.unsplash.com/photo-1634409884980-a30da0b2b010',
    subclasses: ['Archmage', 'Soultaker', 'Mystic Muse', 'Storm Screamer', 'Arcana Lord'],
    color: '#7c5fbf',
  },
  {
    name: 'Archer',
    role: 'Ranged DPS',
    description: 'Cazadores letales de larga distancia. Precisión mortal y movilidad superior.',
    image: 'https://images.unsplash.com/photo-1615672968547-811b8e470371',
    subclasses: ['Sagittarius', 'Moonlight Sentinel', 'Ghost Sentinel', 'Trickster'],
    color: '#10b981',
  },
  {
    name: 'Healer',
    role: 'Support',
    description: 'Guardianes vitales. Sin ellos, ninguna party sobrevive a los desafíos más duros.',
    image: 'https://images.unsplash.com/photo-1667601998053-cd19b2ceb5a5',
    subclasses: ['Cardinal', 'Hierophant', 'Eva\'s Saint', 'Shillien Saint'],
    color: '#d4a843',
  },
];

export const NPC_FEATURES = [
  { name: 'Buffer NPC', description: 'Buffs completos de 2 horas, incluyendo profhetic + dance + song', icon: 'Sparkles' },
  { name: 'GateKeeper', description: 'Teleport gratuito a todas las zonas farmeo y eventos', icon: 'MapPin' },
  { name: 'Class Master', description: 'Cambio de clase gratuito hasta 3rd profession', icon: 'GraduationCap' },
  { name: 'Auction House', description: 'Mercado global con tracking de precios histórico', icon: 'Coins' },
  { name: 'Wedding Manager', description: 'Sistema de matrimonio con buffs especiales para parejas', icon: 'Heart' },
  { name: 'Vote Manager', description: 'Reclama tus rewards de votación de forma instantánea', icon: 'ThumbsUp' },
];

export const EVENTS_SCHEDULE = [
  { time: '00:00', name: 'TvT — Team vs Team', reward: '5 Event Medals', duration: '20 min' },
  { time: '04:00', name: 'CTF — Capture the Flag', reward: '7 Event Medals', duration: '25 min' },
  { time: '08:00', name: 'Deathmatch FFA', reward: '5 Event Medals', duration: '15 min' },
  { time: '12:00', name: 'Fortress Siege Mini', reward: '10 Event Medals', duration: '30 min' },
  { time: '16:00', name: 'Race Event', reward: '4 Event Medals', duration: '10 min' },
  { time: '20:00', name: 'Boss Hunt — World Boss', reward: '15 Event Medals + Drops', duration: '45 min' },
  { time: '23:00', name: 'Last Man Standing', reward: '8 Event Medals', duration: '20 min' },
];

export const FAQ = [
  {
    q: '¿Cuándo abre el servidor?',
    a: 'El Grand Opening es el 15 de Agosto de 2025 a las 21:00 GMT. La beta abierta corre hasta el 10 de Agosto.',
  },
  {
    q: '¿Hay wipe después de la beta?',
    a: 'Sí, todos los personajes de beta serán reseteados. Sin embargo, los reportes de bugs serán recompensados en el live.',
  },
  {
    q: '¿Cuáles son los rates exactos?',
    a: 'EXP/SP x10, Adena x8, Drop/Spoil x6, Quests x4, Raid Boss x3. Diseñado para progresión semanal sin ser pay-to-win.',
  },
  {
    q: '¿El servidor es Pay-to-Win?',
    a: 'No. El donate solo otorga items cosméticos, name change, clan reputation boost, y vote coins extra. Nunca stats ni equipment.',
  },
  {
    q: '¿Qué chronicle es?',
    a: 'Interlude clásico con mejoras de calidad de vida y SubAcu Base +5 propio.',
  },
  {
    q: '¿Hay protección anti-bot?',
    a: 'Sí, sistema heurístico + captcha aleatorio + HWID lock. Bot bans son permanentes.',
  },
];

export const ROADMAP = [
  { phase: 'Beta Cerrada', date: 'Junio 2025', status: 'completed', items: ['Pruebas de stress', 'Balance inicial', 'Bug hunt'] },
  { phase: 'Beta Abierta', date: 'Julio 2025', status: 'active', items: ['Open testing', 'Community feedback', 'Final balance'] },
  { phase: 'Grand Opening', date: '15 Ago 2025', status: 'upcoming', items: ['Server launch', 'Founder rewards', 'Eventos especiales'] },
  { phase: 'Season 1', date: 'Sep — Dic 2025', status: 'planned', items: ['Olympiad oficial', 'Hero crowning', 'Sieges'] },
  { phase: 'Expansion', date: 'Q1 2026', status: 'planned', items: ['Nuevas zonas', 'Custom raids', 'Endgame content'] },
];
